<template>
  <v-dialog :value="show" persistent max-width="500">
    <v-card>
      <v-card-title>
        <span class="title-modal">
          Atenção
        </span>
      </v-card-title>
      <v-card-text>
        <p class="warning-text">
          Atenção: esta operação é irreversível! Ao excluir sua conta,
          eventuais saldos disponíveis serão automaticamente perdidos.
          Verifique se as regras do município presente no
          Termo de Uso permitem o reembolso dos créditos adquiridos.
        </p>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1 text-right">
          <v-btn
              class="btn-custom btn-back mr-2"
              @click.prevent="$emit('cancel')"
              text
          >
            Voltar
          </v-btn>
          <v-btn
              class="btn-custom btn-confirm"
              @click.prevent="$emit('continue')"
              text
          >
            Continuar
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'delete-account-warning-dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
}

.warning-text {
  color: #333;
  line-height: 1.5;
  font-size: 16px;
}

@media only screen and (max-width: 500px) {
  .v-card__actions button {
    width: 100%;
    margin: 5px 0 !important;
  }
}

.btn-custom {
  text-transform: capitalize !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
}

.btn-back {
  background: #003A73 !important;
}

.btn-confirm {
  background: #28a745 !important;
}

.btn-custom:hover {
  background: transparent !important;
  color: #000 !important;
}
</style>
